module.exports = __webpack_public_path__ + "static/media/passionfruit.7ef1e7b8.svg";